import React from 'react';
import { DnaIcon, ArrowRightIcon } from 'lucide-react';
export function UMPSection() {
  return <section className="bg-gradient-to-b from-spiritual-900 via-spiritual-800 to-spiritual-900 py-16 md:py-24 relative overflow-hidden" data-id="element-322">
      <div className="absolute inset-0 opacity-[0.04]" data-id="element-323">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-spiritual-400 rounded-full blur-3xl" data-id="element-324" />
      </div>

      <div className="max-w-4xl mx-auto px-5 md:px-8 relative z-10" data-id="element-325">
        <div className="text-center mb-12" data-id="element-326">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-spiritual-700/50 border border-spiritual-400/30 rounded-full mb-6" data-id="element-327">
            <DnaIcon className="w-8 h-8 text-spiritual-400" aria-hidden="true" data-id="element-328" />
          </div>
          <span className="block text-spiritual-400 font-body text-sm uppercase tracking-widest mb-4" data-id="element-329">
            El Mecanismo Único
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-spiritual-100 leading-tight mb-4" data-id="element-330">
            El Método de{' '}
            <span className="text-gold-gradient" data-id="element-331">Epigenética Emocional</span>
          </h2>
        </div>

        <div className="bg-spiritual-800/50 border-gold-glow rounded-2xl p-6 md:p-10 mb-10" data-id="element-332">
          <p className="text-base md:text-lg text-spiritual-200 font-body leading-relaxed mb-6" data-id="element-333">
            La ciencia confirma que el trauma y el miedo a la pobreza{' '}
            <strong className="text-spiritual-300" data-id="element-334">se heredan en el ADN</strong>
            . Este programa no es contabilidad; es un protocolo de{' '}
            <em className="text-spiritual-400 not-italic font-bold" data-id="element-335">
              "Devolución de Cargas"
            </em>
            .
          </p>
          <p className="text-base md:text-lg text-spiritual-200 font-body leading-relaxed" data-id="element-336">
            Aprenderás a identificar los{' '}
            <strong className="text-spiritual-300" data-id="element-337">
              contratos de lealtad invisible
            </strong>{' '}
            que firmaste inconscientemente con tu árbol genealógico para dejar
            de repetir sus quiebras, sus deudas y sus sacrificios.
          </p>
        </div>

        {/* How It Works - 3 Steps */}
        <h3 className="text-xl md:text-2xl font-heading font-bold text-spiritual-100 text-center mb-10" data-id="element-338">
          ¿Cómo funciona?
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-339">
          <div className="bg-spiritual-800/40 border border-spiritual-700/40 rounded-xl p-6 text-center relative" data-id="element-340">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-spiritual-400/10 border border-spiritual-400/30 rounded-full mb-4" data-id="element-341">
              <span className="text-spiritual-400 font-heading font-bold text-xl" data-id="element-342">
                1
              </span>
            </div>
            <h4 className="font-heading font-bold text-spiritual-100 text-lg mb-3" data-id="element-343">
              Identifica
            </h4>
            <p className="text-spiritual-200/80 font-body text-sm leading-relaxed" data-id="element-344">
              Usas el genograma para ver qué ancestro vivió la escasez que tú
              repites hoy.
            </p>
          </div>

          <div className="bg-spiritual-800/40 border border-spiritual-700/40 rounded-xl p-6 text-center relative" data-id="element-345">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-spiritual-400/10 border border-spiritual-400/30 rounded-full mb-4" data-id="element-346">
              <span className="text-spiritual-400 font-heading font-bold text-xl" data-id="element-347">
                2
              </span>
            </div>
            <h4 className="font-heading font-bold text-spiritual-100 text-lg mb-3" data-id="element-348">
              Devuelve
            </h4>
            <p className="text-spiritual-200/80 font-body text-sm leading-relaxed" data-id="element-349">
              Realizas el ritual de honra y corte para soltar la mochila que no
              te pertenece.
            </p>
          </div>

          <div className="bg-spiritual-800/40 border border-spiritual-700/40 rounded-xl p-6 text-center relative" data-id="element-350">
            <div className="inline-flex items-center justify-center w-12 h-12 bg-spiritual-400/10 border border-spiritual-400/30 rounded-full mb-4" data-id="element-351">
              <span className="text-spiritual-400 font-heading font-bold text-xl" data-id="element-352">
                3
              </span>
            </div>
            <h4 className="font-heading font-bold text-spiritual-100 text-lg mb-3" data-id="element-353">
              Habita
            </h4>
            <p className="text-spiritual-200/80 font-body text-sm leading-relaxed" data-id="element-354">
              Programas tu sistema nervioso para sostener la riqueza sin culpa
              ni miedo.
            </p>
          </div>
        </div>

        <div className="text-center" data-id="element-355">
          <a href="#comprar" className="inline-flex items-center gap-2 bg-gradient-to-r from-spiritual-400 to-spiritual-500 hover:from-spiritual-500 hover:to-spiritual-400 text-spiritual-900 font-body font-bold px-8 py-4 rounded-xl text-base md:text-lg transition-all duration-300 shadow-xl shadow-spiritual-400/20 transform hover:scale-105 active:scale-95" data-id="element-356">
            Quiero Comenzar Mi Sanación
            <ArrowRightIcon className="w-5 h-5" aria-hidden="true" data-id="element-357" />
          </a>
        </div>
      </div>
    </section>;
}